<script>
	export let id;
	export let title;
	export let num;
	export let color;
	export let classes;
	export let percent;

	$: getStyle = () => {
		return `background:${color};transform: scaleX(${percent}`;
	};
</script>

<style type="text/scss">
	@import "./style/vars";
</style>

<div data-id={id} class={classes}>
	<div class="num">{num}</div>
	<div class="metric">
		{#if title}
			<div class="title">{title}</div>
		{/if}
		<div class="legend">
			<div class="legend__bg" />
			<div class="legend__value" style={getStyle()} />
		</div>
	</div>
</div>
